/**
* @description 管理员打卡考勤统计
* @author daxiong
*/
<template>
  <div id="admin-clock">
    <van-tabs v-model="active">
      <van-tab title="员工统计">
        <AdminRecords ></AdminRecords>
      </van-tab>
      <van-tab title="我的统计">
        <ClockRecords></ClockRecords>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import ClockRecords from "./clockRecords";
import AdminRecords from "./../adminRecords";
import { getLocalStorage } from "@utils";

export default {
  components: {
    ClockRecords,
    AdminRecords,
  },
  data() {
    return {
      active: "我的统计",
      userInfo: JSON.parse(getLocalStorage("lishuiUserInfo"))
        ? JSON.parse(getLocalStorage("lishuiUserInfo"))
        : {},
      punchSetting: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    judge() {
      if (this.userInfo.staffType === 1) {
        if (this.userInfo.employeeStatis === 1) {
          this.punchSetting = true;
        } else {
          this.punchSetting = false;
        }
      } else {
        this.punchSetting = true;
      }
    },
  },
  created() {
    this.judge();
  },
  mounted() {},
};
</script>
<style lang='scss' scoped>
#admin-clock {
  ::v-deep .van-tabs {
    .van-tabs__wrap {
      box-shadow: 0 1px 10px 1px rgba(0, 0, 0, 0.05);
      position: relative;
      z-index: 99;
    }
  }
}
</style>